/**
 * Platform Admin Constants & Helpers
 *
 * Hardcoded platform super-admin emails and public domain blocklist.
 * These emails have full platform admin access regardless of domain.
 */

/**
 * Platform super-admin emails (hardcoded, not editable via UI)
 */
export const PLATFORM_ADMIN_EMAILS: string[] = [
  'adamrosemanlsa@gmail.com',
  'ratmr23@gmail.com',
];

/**
 * Check if an email belongs to a platform super-admin
 */
export function isPlatformAdmin(email: string | null | undefined): boolean {
  if (!email) return false;
  return PLATFORM_ADMIN_EMAILS.includes(email.toLowerCase());
}

/**
 * Public email domains that cannot be used for company registration.
 * Platform admin emails are excepted from this check.
 */
export const PUBLIC_EMAIL_DOMAINS: string[] = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'aol.com',
  'icloud.com',
  'mail.com',
  'protonmail.com',
  'zoho.com',
  'yandex.com',
  'gmx.com',
  'fastmail.com',
  'tutanota.com',
  'live.com',
  'msn.com',
  'me.com',
  'mac.com',
];

/**
 * Check if an email domain is a public/consumer domain
 */
export function isPublicDomain(domain: string): boolean {
  return PUBLIC_EMAIL_DOMAINS.includes(domain.toLowerCase());
}

/**
 * Extract domain from an email address
 */
export function getEmailDomain(email: string): string {
  return email.split('@')[1]?.toLowerCase() || '';
}
